import { Constants } from '@/libs/map-draw/lib-utils'
import {
  getFeaturesByLayerId,
  createHoveredSPHelper,
  getStopPointsData,
  createStopPointsHelpers,
  removeStopPointsHelpers,
  removeHoveredSPHelpers,
  nearestPointOnLine,
  isPointInLinkArea,
  getNearestFeature
} from '@/libs/map-draw/helpers'

export const createDrawStopPointsMode = (MapboxDraw, map) => {
  const DrawStopPoints = {}
  const customState = {
    hoveredFeatureId: '',
    no: '',
    fromnodeno: '',
    type: '',
    currentPoint: null,
    projectionPoint: null
  }

  const { ids } = map.$store.state.publicTransport.model

  DrawStopPoints.onTap = DrawStopPoints.onClick = function(state) {
    const {
      hoveredFeatureId,
      currentPoint,
      projectionPoint,
      type
    } = customState

    if (hoveredFeatureId && currentPoint) {
      const { coordinates } = currentPoint
      this.updateUIClasses({ mouse: Constants.cursors.MOVE })
      state.point.updateCoordinate('', coordinates[0], coordinates[1])

      if (type === 'link') {
        state.point.setProperty('link_id', hoveredFeatureId)
      } else {
        state.point.setProperty('node_id', hoveredFeatureId)
      }

      state.point.setProperty('stop_geom', projectionPoint)

      removeStopPointsHelpers(this.map)
      this.map.fire(Constants.events.CREATE, {
        features: [state.point.toGeoJSON()]
      })
      this.changeMode(Constants.modes.SIMPLE_SELECT, {
        featureIds: [state.point.id]
      })
    }
  }

  DrawStopPoints.onMouseMove = function(state, e) {
    const { lng, lat } = e.lngLat
    const nodesFeatures = getFeaturesByLayerId(this.map, e, ids.nodes)
    const linksFeatures = getFeaturesByLayerId(this.map, e, ids.links)

    if (nodesFeatures.length) {
      const feature = getNearestFeature(nodesFeatures, [lng, lat])
      const { coordinates } = feature.geometry

      if (customState.hoveredFeatureId !== feature.properties.id) {
        removeStopPointsHelpers(this.map)
        customState.hoveredFeatureId = ''

        createHoveredSPHelper(this.map, coordinates)
        const { id, no } = feature.properties
        customState.hoveredFeatureId = id
        customState.currentPoint = {
          type: 'Point',
          coordinates
        }
        customState.projectionPoint = {
          type: 'Point',
          coordinates
        }
        customState.type = 'node'
        customState.no = no
      }
    } else if (linksFeatures.length) {
      const link = linksFeatures.find(l =>
        isPointInLinkArea([lng, lat], l.geometry.coordinates, 100)
      )

      if (link) {
        removeHoveredSPHelpers(this.map)
        const nearest = nearestPointOnLine(
          [lng, lat],
          link.geometry.coordinates
        )
        const current = {
          geometry: {
            type: 'Point',
            coordinates: [lng, lat]
          },
          properties: {
            projection: 'true'
          }
        }
        const connection = {
          geometry: {
            type: 'LineString',
            coordinates: [nearest.geometry.coordinates, [lng, lat]]
          }
        }

        const { id, no, fromnodeno } = link.properties
        customState.hoveredFeatureId = id
        customState.type = 'link'
        customState.no = no
        customState.fromnodeno = fromnodeno
        customState.currentPoint = current.geometry
        customState.projectionPoint = nearest.geometry

        const data = getStopPointsData(nearest, current, connection)
        createStopPointsHelpers(this.map, data)
      } else {
        removeStopPointsHelpers(this.map)
        customState.hoveredFeatureId = ''
        customState.type = ''
        customState.currentPoint = null
        customState.projectionPoint = null
      }
    } else {
      removeStopPointsHelpers(this.map)
      customState.hoveredFeatureId = ''
      customState.type = ''
      customState.currentPoint = null
      customState.projectionPoint = null
    }
  }

  return { ...MapboxDraw.modes.draw_point, ...DrawStopPoints }
}
